<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('stations/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('devices.station_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameStationSelected"
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.alias') }}:</strong>
                        </h6>
                        {{ rowData.name2 }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code_serial') }}:</strong>
                        </h6>
                        {{ rowData.code_station }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{ rowData.station_type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('devices.brand') }}:</strong>
                        </h6>
                        {{ rowData.station_mark }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.order') }}:</strong>
                        </h6>
                        {{ rowData.order }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.api_request') }}:</strong>
                        </h6>
                        {{
                          rowData.is_request === 0
                            ? $t('common_words.mayus_no')
                            : $t('common_words.mayus_yes')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('devices.associated_sensors') }}:</strong
                          >
                        </h6>
                        <sensor-list
                          v-if="rowData.climate_sensors.length > 0"
                          :sensorList="rowData.climate_sensors"
                        />
                        <el-tag type="warning" v-else>{{
                          $t('devices.no_associated_sensors')
                        }}</el-tag>
                        <h6 class="my-2 custom-margin-h6-table">
                          <strong>{{ $t('devices.calculations') }}:</strong>
                        </h6>
                        <sensor-list
                          v-if="
                            rowData.calculated_names &&
                            rowData.calculated_names.length > 0
                          "
                          :sensorList="rowData.calculated_names"
                        />
                        <el-tag type="warning" v-else>{{
                          $t('devices.no_associated_calculations')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('devices.nearby_stations') }}:</strong>
                        </h6>
                        <div class="row">
                          <div class="col-4">
                            <p>{{ $t('devices.station') }}:</p>
                          </div>
                          <div class="col-4">
                            <p>{{ $t('devices.associated_sensors') }}:</p>
                          </div>
                          <div
                            class="col-4"
                            v-if="
                              getCalculatedSensorList(rowData.sensors_access)
                                .length > 0
                            "
                          >
                            <p>
                              {{ $t('devices.associated_calculated_sensors') }}:
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            <el-tag
                              type="info"
                              v-if="rowData.stations_access.length > 0"
                              >{{ rowData.stations_access[0].name }}</el-tag
                            >
                            <el-tag type="warning" v-else>{{
                              $t('devices.no_associated_stations')
                            }}</el-tag>
                          </div>
                          <div class="col-4">
                            <template
                              v-if="
                                getSensorList(rowData.sensors_access).length > 0
                              "
                            >
                              <el-tag
                                type="info"
                                v-for="(sensor, key) in getSensorList(
                                  rowData.sensors_access
                                )"
                                :key="`${sensor.id}-${key}`"
                                >{{ `${sensor.code} - ${sensor.name}` }}</el-tag
                              >
                            </template>
                            <el-tag type="warning" v-else>{{
                              $t('devices.does_not_have_sensors_provided')
                            }}</el-tag>
                          </div>
                          <div
                            class="col-4"
                            v-if="
                              getCalculatedSensorList(rowData.sensors_access)
                                .length > 0
                            "
                          >
                            <template>
                              <el-tag
                                type="info"
                                v-for="(sensor, key) in getCalculatedSensorList(
                                  rowData.sensors_access
                                )"
                                :key="`${sensor.id}-${key}`"
                                >{{ `${sensor.code} - ${sensor.name}` }}</el-tag
                              >
                            </template>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in rowData.business_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.associated_farms') }}:</strong
                          >
                        </h6>
                        <span v-for="farm in rowData.farms" :key="farm.name">
                          <el-tag type="info">{{ farm.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.geo_position') }}:</strong
                          >
                        </h6>
                        Lat: {{ rowData.latitude }} - Lon:
                        {{ rowData.longitude }} - Alt: {{ rowData.altitude }}
                        <div class="col-12">
                          <br />
                          <div
                            ref="map"
                            class="map"
                            style="height: 500px"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-3"
          ></card-header>
          <master-table
            :columns="tableColumns"
            :infoTable="queriedData"
            :defaultSort="{ prop: 'name', order: 'descending' }"
          >
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                :minWidth="110"
                @handleDelete="handleDelete"
                @handleEdit="handleEdit"
                @handleView="handleView"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: `${$t('devices.stations_normal')}.pdf`,
            route: 'devices/stations/pdf',
          }"
          :xls="{
            filename: `${$t('devices.stations_normal')}.xlsx`,
            route: 'devices/stations/excel',
          }"
        />
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import configTable from './stationTable';
import { Axios } from 'src/class/Axios.js';
import Fuse from 'fuse.js';
import moment from 'moment';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import SensorList from './SensorLists';

export default {
  components: {
    LPagination,
    [SensorList.name]: SensorList,
  },

  computed: {
    ...configTable().search,
    nameStationSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      stationForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    getSensorList(sensors) {
      try {
        return sensors.filter((sensor) => Number(sensor.calculated) === 0);
      } catch (error) {
        return [];
      }
    },

    getCalculatedSensorList(sensors) {
      try {
        return sensors.filter((sensor) => Number(sensor.calculated) === 1);
      } catch (error) {
        return [];
      }
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;
      this.modals['read'] = true;

      this.loadBaseMap(null);
    },

    handleEdit(_, row) {
      row.url_path_form = '/stations/edit';
      this.stationForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.stationForm));
      this.$router.push({
        path: 'stations/edit',
      });
    },

    handleDelete(_, row) {
      this.stationForm = row;
      SweetAlert.delete(
        `${i18n.t('devices.the_station')} ${this.stationForm.name}`
      ).then((result) => {
        if (result.value) this.deleteStation();
      });
    },

    deleteStation() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.stationForm.route = 'devices/stations';
        Axios.destroyMaster(this.stationForm)
          .then((response) =>
            this.modifyTable(2, this.stationForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('devices/stations')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('devices');
  },

  destroyed() {
    this.deselectedItemOnMenu('devices');
  },
};
</script>
<style></style>
